<template>
  <div>
    <v-btn text color="primary" class="mb-3" :to="{ name: 'ListeSocietes', query: { ...$route.query } }"
      ><v-icon class="mr-2">mdi-arrow-left</v-icon><ressource code="retour_liste"
    /></v-btn>
    <div class="mb-3">
      <h2 class="display mb-2">{{ societe.nom }}</h2>
      <v-btn small v-if="societe.lienModification" :href="societe.lienModification" color="primary" target="_blank"
        ><ressource code="modifier_societe"
      /></v-btn>
    </div>

    <div class="d-flex">
      <CarteInfosOrganisation :societe="societe" class="mr-3">
        <template #infos-societes>
          <CarteIdentificationLigne code="categories" :value="societe.categoriesOrganisation.join(', ')" />
        </template>
      </CarteInfosOrganisation>
      <div>
        <v-card class="pa-4 mb-6" outlined>
          <h3><ressource code="membres" /></h3>
          <v-data-table :items="societe.membres" :headers="membresHeaders">
            <template v-slot:item.role="{ item }">
              <v-chip small v-if="item.estRepondant" color="primary"><ressource code="repondant" /></v-chip>
              <v-chip small v-if="item.estRepondantSubstitut" color="secondary"><ressource code="repondant_substitut" /></v-chip>
            </template>
          </v-data-table>
        </v-card>

        <v-card class="pa-4" outlined>
          <h3><ressource code="pharmacies" /></h3>
          <v-data-table :items="societe.pharmacies" :headers="pharmaciesHeaders"> </v-data-table>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import CarteInfosOrganisation from "../form_parts/CarteInfosOrganisation.vue"
import CarteIdentificationLigne from "../form_parts/CarteIdentificationLigne.vue"
import RessourcesHelpers from "@/components/ui/mixins/RessourcesHelpers"
export default {
  components: { CarteInfosOrganisation, CarteIdentificationLigne },
  mixins: [RessourcesHelpers],
  props: {
    societes: Array,
    id: String
  },
  computed: {
    societe() {
      return this.societes.find((x) => x.id === this.id)
    },
    membresHeaders() {
      return [
        { value: "nomComplet", text: this.getRessource("info_nomComplet") },
        { value: "numeroPermis", text: this.getRessource("info_numeroPermis") },
        { value: "role", text: this.getRessource("info_role") }
      ]
    },
    pharmaciesHeaders() {
      return [
        { value: "numeroEtablissement", text: this.getRessource("info_numeroEtablissement") },
        { value: "adresse", text: this.getRessource("info_adresse") },
        { value: "ville", text: this.getRessource("info_ville") },
        { value: "codePostal", text: this.getRessource("info_codePostal") }
      ]
    }
  },
  created() {
    if (!this.societes || this.societes.length === 0) {
      this.$router.push({ name: "ListeSocietes", query: { ...this.$route.query } })
    }
  }
}
</script>

<style>
</style>